import { gallerySectionFive } from "data/gallerySection";
import useActive from "hooks/useActive";
import Link from "next/link";
import { Col, Image, Row } from "react-bootstrap";
import React, { useState } from "react";
// import Masonry from "react-masonry-component";
import GalleryItem from "./GalleryItem";
import WeDOSectionStaffSol from "components/WeDOSection/WeDOSectionStaffSol";
import MansonryLoader from "components/MansonryLoader/MansonryLoader";
import { useAppStore } from "lib/store";
import { Box, IconButton, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
const masonryOptions = {
  transitionDuration: 500,
};

const { title, tabBtns, items } = gallerySectionFive;

const getCurrentItems = (current = "") =>
  items.filter((it) => it.filter.includes(current));

const getCount = (current = "") => getCurrentItems(current).length;

const GallerySectionFive = ({ portfolio = false, similar = false }) => {
  const [current, setCurrent] = useState("all");
  const currentItems = getCurrentItems(current);
  const ref = useActive("#portfolio");

  const { loading, error, staffSolutions } = useAppStore();

  return (
    <section
      ref={ref}
      className={`gallery-section${similar ? " similar-gallery" : ""}`}
      id="portfolio"
    >
      <div className="auto-container">
        <div className="sec-title centered">
          <h2>
            STAFF SOLUTIONS
            <span className="dot">.</span>
          </h2>
        </div>
        <WeDOSectionStaffSol />
          <Box sx={{ width: '100%', height: 450, overflowY: 'scroll' }}>
            <ImageList variant="masonry" cols={3} gap={8}>
              {Array(staffSolutions.total).fill(0).slice(0, Array(staffSolutions.total).length).map((item, index) => (
                index != 0 && <MansonryLoader
                  key={`${staffSolutions.title}-${index}`}
                  title={staffSolutions.title}
                  count={index}
                  path={staffSolutions.path}
                  alt='Staff-Solutions' />
              ))}
            </ImageList>
          </Box>
      </div>
    </section>
  );
};

export default GallerySectionFive;
